/**
 * Apply `{param: value}` updates to a copy of a URL's search params, keeping
 * every param the caller does not own. `null` or `''` removes the param.
 *
 * The one helper for a page that keeps its filters in the URL and shares the
 * URL with other features (Reports tabs, Products > Client prices): pass it to
 * `setSearchParams((prev) => updateSearchParams(prev, updates))`. Pure.
 */
export function updateSearchParams(
  previous: URLSearchParams,
  updates: Readonly<Record<string, string | null>>,
): URLSearchParams {
  const next = new URLSearchParams(previous);
  for (const [key, value] of Object.entries(updates)) {
    if (value === null || value === '') next.delete(key);
    else next.set(key, value);
  }
  return next;
}
